import { Droplets } from '@tamagui/lucide-icons';
import { useTranslation } from 'react-i18next';
import { Button, Text, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { GlowBackground } from '../../../components/common/GlowBackground';
import { LoadingOverlay } from '../../../components/common/LoadingOverlay';
import { useWaterAlertContext, WaterAlertState } from '../../../contexts/WaterAlertContext';

export const WaterAlertContent = () => {
  const { t } = useTranslation();
  const { alertState, alertMessage, onRequestService, onClearAlert, loading } =
    useWaterAlertContext();

  let icon, color, showRequestService, message;
  switch (alertState) {
    case WaterAlertState.ServiceRequested:
      icon = <Droplets size={80} color={tokens.color.deltaBlue} />;
      color = tokens.color.deltaBlue;
      showRequestService = false;
      message = t('water.serviceRequested');
      break;
    case WaterAlertState.ServiceScheduled:
      icon = <Droplets size={80} color={tokens.color.successGreen} />;
      color = tokens.color.successGreen;
      showRequestService = false;
      message = t('water.serviceScheduled');
      break;
    case WaterAlertState.InProgress:
      icon = <Droplets size={80} color={tokens.color.deltaBlue} />;
      color = tokens.color.deltaBlue;
      showRequestService = false;
      message = t('water.serviceInProgress');
      break;
    case WaterAlertState.Alert:
    default:
      icon = <Droplets size={80} color={tokens.color.warningRed} />;
      color = tokens.color.warningRed;
      showRequestService = true;
      message = alertMessage || t('water.criticalAlert');
      break;
  }

  return (
    <YStack flex={1} gap="$4">
      <LoadingOverlay isVisible={loading} />

      {!loading && (
        <>
          <GlowBackground color={color} />
          <YStack flex={1} justifyContent="center">
            <XStack gap="$4" alignItems="center">
              <YStack width={80} height={80}>
                {icon}
              </YStack>
              <Text color={color} fontSize="$9.5">
                {message}
              </Text>
            </XStack>
          </YStack>
          {/* Always show Clear Alert button for any active alert, but only show Request Service conditionally */}
          <XStack gap="$4">
            {showRequestService && (
              <Button
                flex={1}
                height={72}
                backgroundColor="$deltaBlue"
                borderRadius="$10"
                onPress={onRequestService}
                disabled={loading}>
                <Text color="$white12" fontSize="$8.5">
                  {t('water.requestService')}
                </Text>
              </Button>
            )}
            <Button
              flex={showRequestService ? 1 : 2}
              height={72}
              backgroundColor="$transparent"
              borderRadius="$10"
              borderWidth={2}
              borderColor="$deltaBlue"
              onPress={onClearAlert}
              disabled={loading}>
              <Text color="$white12" fontSize="$8.5">
                {t('water.clearAlert')}
              </Text>
            </Button>
          </XStack>
        </>
      )}
    </YStack>
  );
};
